import truncate from 'lodash/truncate';
import Earth from 'mdi-material-ui/Earth';
import Facebook from 'mdi-material-ui/Facebook';
import GithubCircle from 'mdi-material-ui/GithubCircle';
import Linkedin from 'mdi-material-ui/Linkedin';
import Twitter from 'mdi-material-ui/Twitter';

import styles from './KeyValue.style';
import SocialLink from './SocialLink';

class KeyValue extends React.Component {
  renderItem = (item) => {
    const { classes, double } = this.props;

    if (item.value) {
      const truncatedValue = truncate(item.value, 200);

      let representation;
      if (typeof item.value === 'string') {
        representation = (
          <div className={classes.value} title={item.value}>
            {item.link ? (
              <a href={item.link} rel="noopener noreferrer" target="_blank">
                {truncatedValue}
              </a>
            ) : (
              truncatedValue
            )}
          </div>
        );
      } else {
        representation = item.value;
      }

      return (
        <div
          key={item.label}
          className={classnames(classes.row, {
            [classes.double]: double,
          })}>
          <div className={classes.key}>{item.label}</div>
          {representation}
        </div>
      );
    }
    return null;
  };

  stringOrHandle = (value) => {
    if (typeof value === 'string') {
      return value;
    } else if (typeof value === 'object' && value.handle) {
      return value.handle;
    }
  };

  renderSocial = () => {
    const { classes, social } = this.props;
    const { twitter, facebook, linkedin, github, website } = social;

    return (
      <div className={classes.socialBar}>
        {twitter && (
          <SocialLink
            href={`https://twitter.com/${this.stringOrHandle(twitter)}`}>
            <Twitter />
          </SocialLink>
        )}

        {facebook && (
          <SocialLink
            className={classes.socialIcon}
            href={`https://facebook.com/${this.stringOrHandle(facebook)}`}>
            <Facebook />
          </SocialLink>
        )}

        {github && (
          <SocialLink
            href={`https://github.com/${this.stringOrHandle(github)}`}>
            <GithubCircle />
          </SocialLink>
        )}

        {linkedin && (
          <SocialLink
            href={`https://linkedin.com/${this.stringOrHandle(linkedin)}`}>
            <Linkedin />
          </SocialLink>
        )}

        {website && (
          <SocialLink href={`https://${this.stringOrHandle(website)}`}>
            <Earth />
          </SocialLink>
        )}
      </div>
    );
  };

  render() {
    const { className, classes, data, double, social } = this.props;

    return (
      <div
        className={classnames(classes.root, className, {
          [classes.doubleContainer]: double,
        })}>
        {data.map(this.renderItem)}

        {social && this.renderSocial()}
      </div>
    );
  }
}

KeyValue.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  double: PropTypes.bool,
  data: PropTypes.array.isRequired,
  social: PropTypes.shape({
    twitter: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        handle: PropTypes.string,
      }),
    ]),
    github: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        handle: PropTypes.string,
      }),
    ]),
    facebook: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        handle: PropTypes.string,
      }),
    ]),
    linkedin: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        handle: PropTypes.string,
      }),
    ]),
    website: PropTypes.string,
  }),
};

export default withStyles(styles)(KeyValue);
